import { useCallback, useEffect, useState } from 'react'
import { Control, ControlOptions, DomEvent, DomUtil } from 'leaflet'
import { createPortal } from 'react-dom'
import { useMap } from 'react-leaflet'
import { SideMenu } from './SideMenu'
import { CadastralPlotsLayer } from '../../Layers/CadastralPlotsLayer'
import { TaxonomicPlotsLayer } from '../../Layers/TaxonomicPlotsLayer'
import { ForestHabitatsLayer } from '../../Layers/ForestHabitatsLayer'
import { ForestGroupsLayer } from '../../Layers/ForestGroupsLayer'
import LayersIcon from '@foros-fe/assets/icons/layers.svg'

const controlContainer = DomUtil.create('div')
const LeafletLayerControl = Control.extend({
  onAdd() {
    DomEvent.disableClickPropagation(controlContainer)
    DomEvent.disableScrollPropagation(controlContainer)

    return controlContainer
  },
})

export const LayersControl = ({ position = 'topleft' }: ControlOptions) => {
  const map = useMap()
  const [menuOpen, setMenuOpen] = useState(false)
  const toggleMenu = useCallback(() => setMenuOpen((flag) => !flag), [])

  useEffect(() => {
    const control = new LeafletLayerControl({ position })
    map.addControl(control)

    const closeMenu = () => setMenuOpen(false)
    map.on('exitFullscreen', closeMenu)

    return () => {
      map.removeControl(control)
      map.off('exitFullscreen', closeMenu)
    }
  }, [map, position])

  return (
    <>
      <ForestGroupsLayer />
      <CadastralPlotsLayer />
      <TaxonomicPlotsLayer />
      <ForestHabitatsLayer />
      {createPortal(
        <div className='leaflet-bar'>
          <a className='cursor-pointer' onClick={toggleMenu}>
            <LayersIcon width={19} height={20} />
          </a>
          {menuOpen ? <SideMenu onClose={toggleMenu} /> : null}
        </div>,
        controlContainer
      )}
    </>
  )
}
